import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import Content from "../components/login/Content";

function Login() {
  return (
    <div>
      <NavBar />
      <Content />
      <Footer />
    </div>
  );
}

export default Login;
